import React, { Fragment } from "react";
import { graphql } from "gatsby";
import Seo from "gatsby-plugin-wpgraphql-seo";
import { Layout, Banner } from "../components";
//import { GatsbyImage, getImage } from "gatsby-plugin-image";

import Icon1 from "../images/icon-1.png";
import Icon2 from "../images/icon-2.png";
import Icon3 from "../images/icon-3.png";
import Icon4 from "../images/icon-4.png";
import Icon5 from "../images/icon-5.png";
import Icon6 from "../images/icon-6.png";

const SingleCentre = ({
  data: {
    wp: {
      acfOptionsHeader: {
        siteHeader: { locationsPageBanner },
      },
    },
    wpCentre,
    wpCentre: { centreMeta },
  },
}) => {
  return (
    <>
      <Seo post={wpCentre} />
      <Layout>
        <Banner
          banner={locationsPageBanner}
          title={wpCentre.title}
          caption={
            "<p class='text-3xl text-white'>Dr. Mohan's Diabetes<br />Specialities Centre"
          }
        />
        <section className="bg-white py-16">
          <div className="container mx-auto">
            <p
              className=" mb-16 px-4 text-center font-openSans text-2xl text-black"
              dangerouslySetInnerHTML={{ __html: wpCentre.content }}
            ></p>
            <div className="flex flex-wrap">
              <div className="w-full basis-full px-4 lg:w-1/2 lg:basis-1/2">
                <h2 className=" mb-8 w-full basis-full font-openSans text-4xl uppercase text-secondary">
                  {wpCentre.title}
                </h2>
                {centreMeta.address && (
                  <Fragment>
                    <h3 className="mb-2 font-openSans text-2xl capitalize text-primary">
                      Location Address
                    </h3>
                    <p
                      className="mb-4 font-openSans text-lg text-black"
                      dangerouslySetInnerHTML={{
                        __html: centreMeta.address,
                      }}
                    ></p>
                  </Fragment>
                )}
                {centreMeta.phone && (
                  <p
                    className="font-openSans text-lg text-black"
                    dangerouslySetInnerHTML={{
                      __html: `Phone: <a href="tel:${centreMeta.phone}" class="underline">${centreMeta.phone}</a>`,
                    }}
                  ></p>
                )}
                {centreMeta.email && (
                  <p
                    className="font-openSans text-lg text-black"
                    dangerouslySetInnerHTML={{
                      __html: `Email: <a href="mailto:${centreMeta.email}" class="underline">${centreMeta.email}</a>`,
                    }}
                  ></p>
                )}
                {centreMeta?.doctors?.length > 0 && (
                  <Fragment>
                    <h3 className="mt-8 mb-2 font-openSans text-2xl capitalize text-primary">
                      Doctors
                    </h3>

                    {centreMeta.doctors.map((doctor, index) => (
                      <p className="mb-2 font-openSans text-lg text-black">
                        <a href={doctor.uri} key={index}>
                          {doctor.title}
                        </a>
                      </p>
                    ))}
                  </Fragment>
                )}
              </div>
              <div className="w-full basis-full px-4 pt-4 lg:w-1/2 lg:basis-1/2 lg:pt-0">
                {centreMeta.embedMap ? (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: centreMeta.embedMap,
                    }}
                  ></div>
                ) : null}
              </div>
              <div className="w-full basis-full px-4">
                {centreMeta.factilities && (
                  <Fragment>
                    <h3 className="mt-8 mb-2 font-openSans text-2xl capitalize text-primary">
                      Facilities
                    </h3>
                    <p
                      className="factilities-content mb-4 font-openSans text-lg text-black"
                      dangerouslySetInnerHTML={{
                        __html: centreMeta.factilities,
                      }}
                    ></p>
                  </Fragment>
                )}
              </div>
            </div>
          </div>
        </section>
        <section className="bg-white py-12">
          <div className="container mx-auto">
            <div className="px-4 pb-6">
              <h2 className=" mb-4 text-center font-openSans text-4xl text-secondary">
                What makes us a #1 diabetes specialities centre in India?
              </h2>
              <p className=" mb-0 text-center font-openSans text-2xl text-black">
                When you turn to DMDSC, you’re choosing the best diabetes
                treatment solutions. Below are some numbers that speak volumes
                about our centre:
              </p>
            </div>
            <div className="my-4 flex flex-row flex-wrap">
              <div className=" custom-after relative w-full basis-full rounded-md px-4 text-center lg:w-1/3 lg:basis-1/3">
                <img src={Icon1} alt="" className="inline-block" />
                <p className="mb-8 px-10 font-openSans text-xl text-black">
                  More than 30 Years of Service in prevention and management of
                  diabetes
                </p>
              </div>
              <div className=" custom-after relative w-full basis-full rounded-md px-4 text-center lg:w-1/3 lg:basis-1/3">
                <img src={Icon2} alt="" className="inline-block" />
                <p className="mb-8 px-10 font-openSans text-xl text-black">
                  Clinical excellence based on 30 years of extensive research
                </p>
              </div>
              <div className=" relative w-full basis-full rounded-md px-4 text-center lg:w-1/3 lg:basis-1/3">
                <img src={Icon3} alt="" className="inline-block" />
                <p className="mb-8 px-10 font-openSans text-xl text-black">
                  State of art facilities comparable to the best in the world
                </p>
              </div>
              <div className=" custom-after relative w-full basis-full rounded-md px-4 text-center lg:w-1/3 lg:basis-1/3">
                <img src={Icon4} alt="" className="inline-block" />
                <p className="mb-8 px-10 font-openSans text-xl text-black">
                  With dozens of diabetes hospitals in Tamilnadu, Telangana.
                  Andhra Pradesh, Karnataka, Kerala and other locations
                  throughout India, we set out to make the whole country
                  healthier.
                </p>
              </div>
              <div className=" custom-after relative w-full basis-full rounded-md px-4 text-center lg:w-1/3 lg:basis-1/3">
                <img src={Icon5} alt="" className="inline-block" />
                <p className="mb-8 px-10 font-openSans text-xl text-black">
                  Exclusive range of Diabetes Health Products
                </p>
              </div>
              <div className=" relative w-full basis-full rounded-md px-4 text-center lg:w-1/3 lg:basis-1/3">
                <img src={Icon6} alt="" className="inline-block" />
                <p className="mb-8 px-10 font-openSans text-xl text-black">
                  Customized Diabetes treatment
                </p>
              </div>
            </div>
          </div>
        </section>
      </Layout>
    </>
  );
};

export default SingleCentre;

export const query = graphql`
  query CentreQuery($id: Int) {
    wpCentre(databaseId: { eq: $id }) {
      title
      uri
      content
      centreMeta {
        address
        email
        factilities
        embedMap
        phone
        doctors {
          ... on WpDoctor {
            title
            uri
          }
        }
      }
      seo {
        title
        metaDesc
        focuskw
        metaKeywords
        metaRobotsNoindex
        metaRobotsNofollow
        opengraphTitle
        opengraphDescription
        opengraphImage {
          altText
          sourceUrl
          srcSet
        }
        twitterTitle
        twitterDescription
        twitterImage {
          altText
          sourceUrl
          srcSet
        }
        canonical
        cornerstone
        schema {
          articleType
          pageType
          raw
        }
      }
    }
    wp {
      acfOptionsHeader {
        siteHeader {
          locationsPageBanner {
            desktopImage {
              localFile {
                childImageSharp {
                  gatsbyImageData(layout: FULL_WIDTH, formats: WEBP)
                }
              }
            }
            mobileImage {
              localFile {
                childImageSharp {
                  gatsbyImageData(layout: FULL_WIDTH, formats: WEBP)
                }
              }
            }
            position
            whiteColor
          }
        }
      }
    }
  }
`;
